import React from 'react';
import monthsData from './constants';

const advices = monthsData['advices'].split("--++--");

const AdviceItem = ({ advice, index }) => (
  <li style={styles.adviceItem}>
    <span style={styles.adviceIndex}>{index + 1}. </span>
    {advice}
  </li>
);

const AdviceList = () => (
  <div style={styles.container}>
    <h1 style={styles.title}>Life Advice</h1>
    <ul style={styles.adviceList}>
      {advices.map((advice, index) => (
        <AdviceItem key={index} advice={advice} index={index} />
      ))}
    </ul>
  </div>
);

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    fontFamily: 'Arial, sans-serif',
    color: '#333',
    backgroundColor: '#f9f9f9',
    minHeight: '100vh'
  },
  title: {
    fontSize: '2.5em',
    color: '#4a90e2',
    marginBottom: '20px'
  },
  adviceList: {
    listStyleType: 'none',
    padding: '0',
    maxWidth: '600px'
  },
  adviceItem: {
    fontSize: '1.2em',
    margin: '10px 0',
    padding: '15px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    lineHeight: '1.5'
  },
  adviceIndex: {
    fontWeight: 'bold',
    color: '#4a90e2',
    marginRight: '8px'
  }
};

export default AdviceList;
